module.exports = __webpack_public_path__ + "img/yemen.c9f89aa3.svg";